export enum MfaStatusMessageType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
}
